<template>
    <ul class="radioChoice">
        <li
            v-for="item in radioList"
            :key="item.id"
            @click="$emit('checkRadio',item.id)"
            :class="{active: checkId === item.id}"
        >
            {{item.title}}
        </li>
    </ul>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  props: {
    radioList: {
      default: [],
    },
    checkId: {
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>
.radioChoice {
    li {
        width: 605px;
        height: 91px;
        margin: 0 auto 22px;
        font-size: 25px;
        line-height: 91px;
        text-align: center;
        border: 2px solid #E8E8E8;
        border-radius: 45px;
    }
    .active {
        color: #fff;
        background: #FF7F41;
        border: none;
    }
}
</style>
